// The campaign tags of the link a player arrived by (utm_*, an ad network's click id, a ref code), kept in
// session storage for this tab only and sent once with sign-up (server/attribution.ts). No cookies, nothing
// sent anywhere else. The first tagged link in a tab wins, so wandering to /terms and back keeps it.
const KEY = 'lk-attr';
const PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'ref',
  'fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid', 'rdt_cid', 'twclid', 'msclkid'];

function capture() {
  try {
    if (sessionStorage.getItem(KEY)) return;
    const q = new URLSearchParams(location.search);
    const a: Record<string, string> = {};
    for (const p of PARAMS) { const v = q.get(p); if (v) a[p] = v.slice(0, 120); }
    let ref = '';
    try { const r = document.referrer ? new URL(document.referrer) : null; if (r && r.host !== location.host) ref = r.hostname.replace(/^www\./, ''); } catch { /* bad referrer */ }
    if (ref) a.referrer = ref;
    if (!Object.keys(a).length) return;
    a.landing = location.pathname.slice(0, 60);
    sessionStorage.setItem(KEY, JSON.stringify(a));
  } catch { /* storage blocked: sign-up still works, just untagged */ }
}
capture();

/** The stored tags as a string for the sign-up body; empty when the player came in untagged. */
export function attributionField(): string {
  try { return sessionStorage.getItem(KEY) ?? ''; } catch { return ''; }
}
